/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { ArrowLeft, ArrowRight, ChevronDown, MapPin, PlusCircle, Truck } from 'react-feather'
import Pill from '../skeletons/Pill'
import PreviewBanner from '../sub-components/PreviewBanner'
import { OrderSummaryConfigType } from 'src/lib/types/customizeUI'
import { useLocale } from 'src/lib/hooks/useLocal'

const PreviewDeliveryInformation: React.FC<OrderSummaryConfigType> = ({ isOnePageCheckoutEnable }) => {
  const { t } = useLocale()
  const [showAddressList, setShowAddressList] = useState(false)
  return (
    <>
      {isOnePageCheckoutEnable && (
        <>
          {!showAddressList ? (
            <div className='font-semibold text-sm w-full text-coal-dark'>{t('delivery_title')}</div>
          ) : null}
          {!showAddressList ? (
            <div className='border-1 p-3 border-gray-light rounded-2xl w-full flex flex-col bg-white shadow-[0px_0px_10px_0px_rgba(0,0,0,0.05)]'>
              <div className='flex justify-between items-start'>
                <div className='flex items-center'>
                  <div className='mr-2'>
                    <MapPin />
                  </div>
                  <div className='text-sm font-semibold'>{t('Deliver To')}</div>
                </div>
                <div className='flex items-center' onClick={() => setShowAddressList(true)}>
                  <div className='font-semibold text-sm'>{t('change')}</div>
                  <div className='ml-2'>
                    <ArrowRight />
                  </div>
                </div>
              </div>
              <div className='mt-3'>
                <Pill height={0.9} width={17} />{' '}
              </div>
              <div className='mt-3'>
                <Pill height={0.8} width={15} />{' '}
              </div>
              <div className='text-left text-xs mt-3'>
                <p>{t('delivery_subtitle')}</p>
              </div>
            </div>
          ) : null}
        </>
      )}
      {!showAddressList && isOnePageCheckoutEnable && (
        <div className='border-1 p-3 border-gray-light rounded-2xl w-full flex flex-col bg-white shadow-[0px_0px_10px_0px_rgba(0,0,0,0.05)]'>
          <div className='flex justify-between items-start'>
            <div className='flex items-center'>
              <div className='mr-2'>
                <Truck />
              </div>
              <div className='text-sm font-semibold'>{t('shipping_opc')}</div>
            </div>
            <div className='flex items-center'>
              <div
                className='font-semibold text-sm'
                style={{
                  color: '#2C874A'
                }}
              >
                {t('free')}
              </div>
              <div className='ml-2'>
                <ChevronDown />
              </div>
            </div>
          </div>
        </div>
      )}
      {showAddressList && isOnePageCheckoutEnable && (
        <div className='w-full pt-1 z-10 bg-white absolute top-0'>
          <div className='w-full'>
            <div className='flex justify-items-start items-center p-3'>
              <div onClick={() => setShowAddressList(false)}>
                <ArrowLeft />
              </div>
              <div className='ml-1 text-sm font-semibold'>{t('add_address')}</div>
            </div>
            <PreviewBanner backgroundColor={'black'} textColor={'white'} bannerText={'Address banner'} />
            <div className='p-4 space-y-4'>
              <div className={`border-1 border-gray-light rounded-2xl w-full flex flex-col bg-white`}>
                <div
                  className={`flex h-[3.25rem] px-3 w-full cursor-pointer flex-row items-center rounded-[inherit] focus:outline-none `}
                >
                  <div className='flex w-full flex-row space-x-2 items-center justify-center'>
                    <PlusCircle
                      style={{
                        color: '#2C874A'
                      }}
                    />
                    <div>{t('add_new_address')}</div>
                  </div>
                </div>
              </div>
              <div className='flex flex-col space-y-4'>
                <div className='border-1 p-3 items-start gap-2.5 border-black rounded-2xl w-full flex flex-col bg-white shadow-[0px_0px_10px_0px_rgba(0,0,0,0.05)]'>
                  <div className='flex flex-row gap-2.5 justify-center'>
                    <Pill height={1} width={1} />
                    <Pill height={1} width={5} />
                  </div>
                  <Pill height={5} width={17} />
                </div>
                {[...Array(2)].map((_, index) => (
                  <div className='border-1 p-3 items-start gap-2.5 border-gray-light rounded-2xl w-full flex flex-col bg-white shadow-[0px_0px_10px_0px_rgba(0,0,0,0.05)]'>
                    <div className='flex flex-row gap-2.5 justify-center'>
                      <Pill height={1} width={1} />
                      <Pill height={1} width={5} />
                    </div>
                    <Pill height={5} width={17} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PreviewDeliveryInformation
